module.exports = __webpack_public_path__ + "static/media/LayoutImportacaoParceiro.b32a6559.xlsx";